module.exports = __webpack_public_path__ + "img/paperclip.9828a01b.svg";